'use strict';

/**
 * Get cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @returns {string} cookie value of the found cookie name
 */
function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

/**
 * Function to set the cookie
 * @param {*} cookieName 
 * @param {*} cookieValue 
 * @param {*} days 
 * @param {*} domain
 */
function setCookie(name, value, days, domain) {
    if (!name) { return; }

    var cookie = name + "=" + encodeURIComponent(value) + "; Path=/";

    if (days && Number(days) > 0) {
    var date = new Date();
    date.setTime(date.getTime() + (Number(days) * 24 * 60 * 60 * 1000));
    cookie += "; Expires=" + date.toUTCString();
    }

    if (domain) {
        cookie += "; Domain=" + domain;
    }

    // Required for cross-site/iframe contexts: SameSite=None and Secure (HTTPS)
    cookie += "; SameSite=None; Secure";

    // Assign the cookie
    document.cookie = cookie;
}

/**
 * Function to delete the cookie
 * @param {*} cookieName 
 */
function deleteCookie(cookieName) {
    document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

/**
 * Function to check whether tracking query params are existing - Google ads
 * @returns 
 */
function hasTrackingParams() {
    if (
        !window.pageContext ||
        !window.pageContext.trackingParams ||
        !window.pageContext.trackingParams.param
    ) {
        return false;
    }
    var url = window.location.href;
    return window.pageContext.trackingParams.param
        .split(',')
        .some(function (param) {
            return url.indexOf(param.trim() + '=') > -1;
        });
}

/**
 * Function to set the cookie when country switcher is off
 */
function setDefaultPreferredCookie() {
    if ($('.js-header-main .location').length > 0) {
        var countrySwitcherEnabled = $('.js-header-main .location').data('enable-country-switcher');
        var geoLocation = $('.js-header-main .location').data('geo-country');
        var locale = $('body').data('locale');
        var defaultCurrency = $('.js-header-main .location').data('default-currency');
        var existingCurrency  = getCookie('preferredCurrency');
        var hasTrackingParam = hasTrackingParams();
        if ((existingCurrency !== defaultCurrency && !countrySwitcherEnabled) || hasTrackingParam){
            deleteCookie('preferredCountry');
            deleteCookie('preferredCurrency');
            deleteCookie('countryPopupShown');
            deleteCookie('code');
            setCookie('countryPopupShown', 'true', 7);
            setCookie('preferredCountry', geoLocation, 7);
            setCookie('code', locale, 7);
            setCookie('preferredCurrency', defaultCurrency, 7);
        }
    }
}

function main() {
    var previousSessionID = window.localStorage.getItem('previousSid');
    var currentSessionID = getCookie('sid');
    var cookiePolicyAccepted = window.localStorage.getItem('cookiePolicyAccepted');

    if ((!previousSessionID && currentSessionID)) {
        if (!cookiePolicyAccepted) {
            previousSessionID = currentSessionID;
            window.localStorage.setItem('previousSid', previousSessionID);
            $('#cookiePolicy').modal('show');
        }
        // When a user first time visit the home page,
        // set the previousSessionID to currentSessionID
        // and Show the cookie alert
    } else if (previousSessionID && previousSessionID === currentSessionID) {
        // Hide the cookie alert if user is in the same session
        if (cookiePolicyAccepted) {
            $('#cookiePolicy').modal('hide');
        } else {
            $('#cookiePolicy').modal('show');
            $('.modal-backdrop').css('background-color', '#fff');
            $('.modal-backdrop.show').css('opacity', 0.8);

        }
    } else {
        // Clear the previousSessionID from localStorage
        // when user session is changed or expired
        window.localStorage.removeItem('previousSid');
    }

    $('body').on('click', '.affirm', function () {
        var cookieHelper = require('../../js/components/cookie');
        window.localStorage.setItem('cookiePolicyAccepted', 'true');
        if ($('.js-header-main .location').length > 0) {
            var countrySwitcherEnabled = $('.js-header-main .location').data('enable-country-switcher');
            var hasTrackingParam = hasTrackingParams();
            if (!countrySwitcherEnabled) {
                setDefaultPreferredCookie();
                return;
            }
            if (hasTrackingParam) {
                setDefaultPreferredCookie();
            }
        }

        //load popup for the first time
        var popupShown = cookieHelper.getCookie('countryPopupShown');
        if (!popupShown) {
            $('#countryCurrencyLanguageModal').modal('show');
        } else {
            $('#countryCurrencyLanguageModal').modal('hide');
            $('#countryCurrencyLanguageModal .modal-header .close'). removeClass('hidden');
        }
    });
}

module.exports = {
    main: main,
    getCookie: getCookie,
    setCookie: setCookie,
    deleteCookie: deleteCookie,
    setDefaultPreferredCookie:setDefaultPreferredCookie,
    hasTrackingParams: hasTrackingParams
};